import { Link } from 'react-router-dom'
import MediaImage from './MediaImage'
import { homeCategory, type Story } from '../data/content'
import { storyPath } from '../lib/paths'

type Props = {
  story: Story
  compact?: boolean
  showCategory?: boolean
}

export default function StoryRow({ story, compact = false, showCategory = true }: Props) {
  const isLook = homeCategory(story) === 'Look Books'
  const thumb = compact ? 'size-14' : 'size-[96px]'
  return (
    <Link
      to={storyPath(story.slug)}
      className={`flex min-w-0 items-start gap-4 border-b border-rule last:border-b-0 hover:text-rose ${compact ? 'py-2.5' : 'py-5'}`}
    >
      {story.image ? (
        <MediaImage
          src={story.image}
          size="thumb"
          alt={story.title}
          className={`${thumb} shrink-0 bg-sand-2 ${isLook ? 'object-contain object-center' : 'object-cover object-top'}`}
        />
      ) : (
        <span className={`${thumb} shrink-0 bg-sand-2`} role="img" aria-label={story.title} />
      )}
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-caps flex gap-3 text-stone">
          {showCategory && <span className="text-rose">{story.category}</span>}
          <span>{story.date}</span>
        </span>
        <span className={`${compact ? 'text-caps-h4' : 'text-caps-h3'} break-words text-ink`}>{story.title}</span>
        {story.dek && (
          <span className={`leading-snug text-muted ${compact ? 'line-clamp-2 text-sm' : 'text-base'}`}>
            {story.dek}
          </span>
        )}
      </span>
    </Link>
  )
}
